export enum UserRole {
  SUPER_ADMIN = 1,
  ADMIN,
  PATIENT,
  SPECIALIST,
  HOSPITAL_POC,
}

export enum Gender {
  Male = 1,
  Female,
  Other,
}

export enum ConsultationStatus {
  AwaitingDoctorReview = 1,
  UnderReviewByDoctor = 2,
  DoctorChatActive = 3,
  ReportReady = 4,
  Completed = 5,
  FollowUpEligible = 6,
  FollowUpExpired = 7,
  ReferredInternal = 8,
  ReferredExternal = 9,
  CancelledByPatient = 10,
  Overdue = 11,
  SpecialistAllocationPending = 12,
}

export enum ConsultationType {
  'Online Second Opinion' = 1,
  'Follow Up Second Opinion' = 2,
  'Referral Second Opinion' = 3,
  'Hospital Follow Up Second Opinion' = 4,
  'Hospital Referral Second Opinion' = 5,
}

export enum ConsultationGroup {
  Ongoing = 1,
  Past = 2,
  ConsultationHistory = 3,
}

export enum ConsultationAction {
  View = 1,
  Feedback,
  FollowUp,
  Cancel,
  Upload,
  Report,
  Referral,
  LinkedTo,
  Chat,
}

export enum StatusBadgeVariant {
  YELLOW = 1,
  ORANGE,
  ORANGE_LIGHT,
  RED,
  GREEN,
  BLUE,
  GREY,
  DARK_BLUE,
  DARK_GRAY,
  FADE_BLUE,
  DARK_ORANGE,
  FADE_ORANGE,
  LIGHT_GREEN,
  PEARL_BLUE,
  LIGHT_BLUE,
}

export enum SortOption {
  ASC = 1,
  DESC,
}

export enum ReferralType {
  Internal = 1,
  External = 2,
}

export enum SpecialistProfileStatus {
  NotApplicable = -1,
  NotStarted = 0,
  Pending = 1,
  EligibleForApproval = 2,
  AwaitingAdminApproval = 3,
  ChangeRequested = 4,
  Approved = 5,
  ReSubmitted = 6,
  ProfileEdited = 7,
  ReChangeRequested = 8,
  ReEditAfterReChangeRequested = 9,
}

export enum SpecialistOnboardingStatus {
  Incomplete = 1,
  UnderReview = 2,
  ChangesRequested = 3,
  Approved = 4,
  ProfileEdited = 5,
}

export enum AdminRole {
  PatientAdmin = 1,
  FinanceAdmin = 2,
  SpecialistAdmin = 3,
  SupportAdmin = 4,
  HospitalAdmin = 5,
}

export enum ChatMessageStatus {
  Sent = 1,
  Delivered = 2,
  Read = 3,
  Failed = 4,
}

export enum ResourceType {
  User = 1,
  ConsultationCase = 2,
  Message = 3,
  Referral = 4,
  Document = 5,
  Payment = 6,
  Feedback = 7,
  Notification = 8,
  AccountDeletionTicket = 9,
  SpecialistProfileChangeRequest = 10,
  UserQueryTicket = 11,
  FilterOption = 12,
  Category = 13,
  AccountExportTicket = 14,
  ConsultationSummary = 15,
  SpecialistInvitation = 16,
  PopularityLimit = 17,
  AdminRole = 18,
  LicenseVerificationMode = 19,
  Favourite = 20,
  Specialist = 21,
  Hospital = 22,
}
export enum ActionType {
  Created = 1,
  Updated = 2,
  Deleted = 3,
  Login = 4,
  View = 5,
  Signup = 6,
  Selected = 7,
  Cancelled = 8,
  Activated = 9,
  Deactivated = 10,
  Logout = 11,
  Assigned = 12,
  Requested = 13,
}

export enum FilterType {
  Experience = 1,
  Rating = 2,
  Charges = 3,
}

export enum PatientAccountTicketRequestStatus {
  NotApplicable = 0,
  Requested = 1,
  Exported = 2,
  Pending = 3,
  Approved = 4,
  Paused = 5,
  Resumed = 6,
  Deleted = 7,
  Cancelled = 8,
}

export enum HelpRequestUserType {
  Patient = 1,
  Specialist = 2,
  Visitor = 3,
  HospitalPoc = 4,
}

export enum HelpRequestStatus {
  Open = 1,
  Closed = 2,
  Spam = 3,
}

export enum HospitalAdminRole {
  NotApplicable = 0,
  Requested = 1,
  Exported = 2,
  Pending = 3,
  Approved = 4,
  Paused = 5,
  Resumed = 6,
  Deleted = 7,
  Cancelled = 8,
}

export enum HospitalType {
  MultispecialityHospital = 1,
  SuperspecialityHospital,
  SpecialityHospital,
  Polyclinic,
  DaignosticCenter,
}

export enum HospitalSpecialistOnboardingStatus {
  Invited = 1,
  Registered = 2,
  Active = 3,
}

export enum PatientAccountTicketType {
  ExportOnly = 1,
  ExportDelete = 2,
}

export enum SpecialistPayoutStatus {
  Pending = 1,
  Paid = 2,
  Cancelled = 3,
}

export enum ConsulationFlowType {
  Regular = 1,
  PreSelectedSpecialist = 2,
  FollowUp = 3,
  Referral = 4,
  HospitalSpecialistAssigned = 5,
  HospitalSpecialistPreSelected = 6,
  HOSPITAL_SPECIALIST_FOLLOWUP = 7,
  HOSPITAL_SPECIALIST_REFFERAL = 8,
}

export enum SpecialistEntityType {
  Specialist = 1,
  Hospital = 2,
}

export enum ProgressBarSteps {
  NotStarted = 0,
  CaseAnalysisStarted = 1,
  DocumentSent,
  DocomentAnalysisStarted,
  DocomentAnalysisCompleted,
  SpecialistFetched,
  ConsultationCaseUpdated,
  Complete,
}

export enum UploadAdditionalFilesProgressBarSteps {
  NotStarted = 0,
  DocumentSent,
  ValidatingFiles,
  CheckingForDuplicates,
  UpdatingCaseSummary,
  Complete,
}

export enum LoaderBarType {
  PatientDashboard = 1,
  PatientConsultation = 2,
}

// export LicenveVerificationModalState {
//   Open = 1,
//   Closed = 2,
// }

export enum LicenceVerificationMode {
  Manual = 1,
  Automatic = 2,
}

export enum HospitalSpecialistAssignmentStatus {
  Pending = 1,
  Assigned = 2,
  Cancelled = 3,
}
export enum ChatMessageType {
  Text = 1,
  DocumentRequest = 2,
}
